import { AreaUnlockPopupLayout } from 'Layouts/Farm/AreaUnlockPopupLayout';
import { PopupID } from "State/UI/PopupID";
import BaseUISystem from "System/UI/BaseUISystem";
import RelativePositionComponent from "Component/Render/RelativePosition";
import Game from "Game";
import { FarmAreaId } from "State/Player/Farm/IFarmPlayerState";
import BaseMenu from "System/UI/Menu/BaseMenu";
import { AreaData, IAreaData } from "../FarmHelpers";
import GameObject, { GameObjectEvent } from "GameObject/GameObject";
import { UIActions } from "State/UI/UIActions";
import Renderable from "Component/Renderable";
import { FarmActions } from "State/Farm/FarmActions";
import TextComponent from "Component/Render/Text";
import CoinBar from "Prefabs/UI/HUD/CoinBar";
import { ProductId } from "Utility/Product";
import TransformComponent from "Component/Transform";
import FarmMapHandler from "./FarmMapHandler";
import { PlaySound } from "System/Audio/AudioHelper";

export default class AreaUnlockPopup extends BaseMenu {
    private layout: any;
    private areaID: FarmAreaId;
    private areaData: IAreaData;

    private borderArea: GameObject;
    private coinBar: CoinBar;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FARM_AREA_UNLOCK, uiSystem, false);
    }

    public onShow(areaID: FarmAreaId): void {
        this.areaID = areaID;

        this.areaData = AreaData[this.areaID];
        const borderArea = FarmMapHandler.getAreaLayout(areaID).border_area;

        this.borderArea = borderArea;

        this.layout = new AreaUnlockPopupLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = this.areaData.offset;
        this.element.addChild(this.layout.root);

        this.coinBar = GameObject.Instantiate(CoinBar);
        this.coinBar.container.resize = () => void 0;
        this.coinBar.container.position.set(0);
        this.layout.coinBarContainer.addChild(this.coinBar);

        this.borderArea.setDisplayParent(this.system.overlayPopup);

        const item = this.layout.itemsContainer.children.find((item:any) => item.container.name === this.areaID);
        if(item) item.getComponent(Renderable).visible = true;

        this.setButtons();
    }

    private readonly setButtons = () => {
        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.onCloseClick);
        this.layout.buyButton.on(GameObjectEvent.SELECTED, this.onBuyClick);

        let price: string;
        if(!this.areaData.price) {
            this.layout.coin.getComponent(Renderable).visible = false;
            price = Game.sdk.getCatalog().products.find((e) => e.productId === ProductId.FARM_UNLOCK_AREA).price;
            this.layout.areaPrice.getComponent(TransformComponent).x -= 36;
        } else {
            price = this.areaData.price.toString();
        }


        this.layout.areaPrice.getComponent(TextComponent).text = price;
    }

    private readonly onBuyClick = async (): Promise<void> => {
        PlaySound('purchase_new_area');

        FarmActions.purchaseFarmArea(this.areaID);
    };

    private readonly onCloseClick = () => {
        UIActions.hidePopup(PopupID.FARM_AREA_UNLOCK);
    };

    protected onHide(params?: any) {
        super.onHide(params);

        // Make sure to re-parent the border area whenever this popup is closed.
        this.borderArea.removeDisplayParent();
    }
}
